import { fetchUtils } from "react-admin";

import { getAccessToken } from "./auth/accessToken";
import { buildAuthHeaders } from "./auth/authHeaders";
import { getUserManager } from "./oidc/userManager";

export const fetchJson = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }

  const token = await getAccessToken();
  const auth = buildAuthHeaders(token);
  Object.entries(auth).forEach(([k, v]) => {
    if (v != null) {
      options.headers.set(k, v);
    }
  });

  return fetchUtils.fetchJson(url, options);
};

const authProvider = {
  login: () => {
    const um = getUserManager();
    return um.signinRedirect();
  },

  logout: async () => {
    localStorage.removeItem("role");
    const um = getUserManager();
    const user = await um.getUser();
    await um.removeUser();

    if (!user) {
      return Promise.resolve();
    }

    try {
      await um.signoutRedirect(
        user.id_token ? { id_token_hint: user.id_token } : undefined
      );
      return new Promise(() => {});
    } catch {
      return Promise.resolve();
    }
  },

  checkError: async ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem("role");
      const um = getUserManager();
      await um.removeUser();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: async () => {
    const token = await getAccessToken();
    return token ? Promise.resolve() : Promise.reject();
  },

  getIdentity: async () => {
    const {
      json: {
        user: { user_guid, first_name, last_name, image_url, role },
      },
    } = await fetchJson(
      `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_WHOAMI_PATH}`
    );

    localStorage.setItem("role", role);

    return {
      id: user_guid,
      fullName: `${first_name} ${last_name}`,
      avatar: image_url,
    };
  },

  getPermissions: async () => {
    return localStorage.getItem("role");
  },
};

export default authProvider;
